import React from 'react';
import { Box } from '@mui/material';
import {
    FaChartBar,
    FaExclamationTriangle,
    FaHeartbeat,
} from 'react-icons/fa'; 
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import SecurityChartsContainer from '../../Seguranca/Common/SecurityChartsContainer';
import OcurrencesWrapper from './Ocurrences';
import CrimesWrapper from './Crimes';
import SpotsWrapper from './Spots';
import RankingsWrapper from './Rankings';



const Weapons = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate(`/governanceroom/${props.dashboardPath}`);
    };

    const menus = [
        {
            title: 'Mapeamento',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/spots`,
            icon: <FaExclamationTriangle style={{ marginRight: '5px' }} />
        },
        {
            title: 'Ocorrências',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/ocurrences`,
            icon: <FaChartBar style={{ marginRight: '5px' }} />
        },
        {
            title: 'Crimes',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/crimes`,
            icon: <FaHeartbeat style={{ marginRight: '5px' }} />
        },
        {
            title: 'Rankings',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/rankings`,
            icon: <FaExclamationTriangle style={{ marginRight: '5px' }} />
        },
    ];
    
    const titleMap = {
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/ocurrences`]:'Resultados Gerais das Ocorrências',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/crimes`]: 'Resultados dos Indicadores de Crimes',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/spots`]: 'Resultados dos Indicadores de Locais',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/rankings`]: 'Rankings'
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <SecurityChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="spots" replace />}
                        />
                        <Route
                            path="ocurrences"
                            element={<OcurrencesWrapper />}
                        />
                        <Route
                            path="crimes"
                            element={<CrimesWrapper />}
                        />
                        <Route
                            path="spots"
                            element={<SpotsWrapper />}
                        />
                        <Route
                            path="rankings"
                            element={<RankingsWrapper />}
                        />
                    </Routes>
                </SecurityChartsContainer>
            </Box>
        </Box>
    );
};

export default Weapons;
